import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/ComingSoon.scss'

const ServerErrorPage: React.FC = () => {
    const retry = () => window.location.reload()

    return (
        <main className="recovery-page" aria-labelledby="server-error-title">
            <section className="recovery-card">
                <p className="recovery-eyebrow">Error 500</p>
                <h1 id="server-error-title">We could not load this page</h1>
                <p className="recovery-message">The console could not complete that request. Try again, or return to the dashboard while we recover.</p>
                <div className="recovery-actions">
                    <button type="button" className="recovery-action recovery-action--primary" onClick={retry}>
                        Try again
                    </button>
                    <Link className="recovery-action" to="/">
                        Go to dashboard
                    </Link>
                </div>
                <a className="recovery-support" href="mailto:office@redu.cloud">
                    Contact support
                </a>
            </section>
        </main>
    )
}

export default ServerErrorPage
